import $ from 'jquery'
import 'datatables.net'



/* DATA TABLE
----------------------------------------------------------------------------------------------------*/

export default class DataTable {

    constructor($el) {
        this.$el = $($el[0])
        this.initTable()
    }


    initTable() {
        this.DT = this.$el.DataTable({
            info: false,
            searching: false,
            paging: false,
            columnDefs: [
                { targets: 'no-sort', orderable: false },
            ],

            language: {
                lengthMenu: 'Résultats par page _MENU_',
            },
        })
    }


    /* Values
    --------------------------------------------------------- */

}




/* CONSTANTS AND HELPERS
---------------------------------------------------------------------------------------------------- */



